import { PostcodeData, PricingData } from '../../domain/models/pages/BillingGuideLookupPage/BillingGuideLookupModel'
import { Hit } from '../../domain/models/rest/SearchResponse'
import RequestError from '../../errors/RequestError'
import { BaseAction, DataAction } from '../commons'

// Action types

export const BILLING_GUIDE_FETCH_POSTCODES = 'BILLING_GUIDE/FETCH_POSTCODES'
export const BILLING_GUIDE_FETCH_POSTCODES_SUCCESS = 'BILLING_GUIDE/FETCH_POSTCODES_SUCCESS'
export const BILLING_GUIDE_FETCH_POSTCODES_FAIL = 'BILLING_GUIDE/FETCH_POSTCODES_FAIL'

export const BILLING_GUIDE_FETCH_CLINICS = 'BILLING_GUIDE/FETCH_CLINICS'
export const BILLING_GUIDE_FETCH_CLINICS_SUCCESS = 'BILLING_GUIDE/FETCH_CLINICS_SUCCESS'
export const BILLING_GUIDE_FETCH_CLINICS_FAIL = 'BILLING_GUIDE/FETCH_CLINICS_FAIL'

export const BILLING_GUIDE_FETCH_PRICING = 'BILLING_GUIDE/FETCH_PRICING'
export const BILLING_GUIDE_FETCH_PRICING_SUCCESS = 'BILLING_GUIDE/FETCH_PRICING_SUCCESS'
export const BILLING_GUIDE_FETCH_PRICING_FAIL = 'BILLING_GUIDE/FETCH_PRICING_FAIL'

export const BILLING_GUIDE_SET_SELECTED_POSTCODE = 'BILLING_GUIDE/SET_SELECTED_POSTCODE'
export const BILLING_GUIDE_SET_SELECTED_CLINIC = 'BILLING_GUIDE/SET_SELECTED_CLINIC'
export const BILLING_GUIDE_SET_POSTCODE_INPUT = 'BILLING_GUIDE/SET_POSTCODE_INPUT'
export const BILLING_GUIDE_CLEAR_POSTCODE_SUGGESTIONS = 'BILLING_GUIDE/CLEAR_POSTCODE_SUGGESTIONS'
export const BILLING_GUIDE_SET_SELECTED_PROCEDURE = 'BILLING_GUIDE/SET_SELECTED_PROCEDURE'

// Action Creators

// Postcode Actions
export const fetchPostcodes = (postcode: string): DataAction<{ postcode: string }> => ({
  type: BILLING_GUIDE_FETCH_POSTCODES,
  data: { postcode },
})

export const fetchPostcodesSuccess = (postcodes: Hit<PostcodeData>[]): DataAction<Hit<PostcodeData>[]> => ({
  type: BILLING_GUIDE_FETCH_POSTCODES_SUCCESS,
  data: postcodes,
})

export const fetchPostcodesFail = (error: string): DataAction<RequestError> => ({
  type: BILLING_GUIDE_FETCH_POSTCODES_FAIL,
  data: new RequestError(error),
})

// Clinic Actions
export const fetchClinics = (lat: string, lon: string): DataAction<{ lat: string; lon: string }> => ({
  type: BILLING_GUIDE_FETCH_CLINICS,
  data: { lat, lon },
})

export const fetchClinicsSuccess = (clinics: string[]): DataAction<string[]> => ({
  type: BILLING_GUIDE_FETCH_CLINICS_SUCCESS,
  data: clinics,
})

export const fetchClinicsFail = (error: string): DataAction<RequestError> => ({
  type: BILLING_GUIDE_FETCH_CLINICS_FAIL,
  data: new RequestError(error),
})

// Pricing Actions
export const fetchPricing = (
  clinicName: string,
  procedureName: string,
): DataAction<{ clinicName: string; procedureName: string }> => ({
  type: BILLING_GUIDE_FETCH_PRICING,
  data: { clinicName, procedureName },
})

export const fetchPricingSuccess = (pricing: PricingData[]): DataAction<{ pricing: PricingData[] }> => ({
  type: BILLING_GUIDE_FETCH_PRICING_SUCCESS,
  data: { pricing },
})

export const fetchPricingFail = (error: string): DataAction<RequestError> => ({
  type: BILLING_GUIDE_FETCH_PRICING_FAIL,
  data: new RequestError(error),
})

// Selection Actions
export const setSelectedPostcode = (postcode: PostcodeData | null): DataAction<PostcodeData | null> => ({
  type: BILLING_GUIDE_SET_SELECTED_POSTCODE,
  data: postcode,
})

export const setSelectedClinic = (clinic: string | null): DataAction<string | null> => ({
  type: BILLING_GUIDE_SET_SELECTED_CLINIC,
  data: clinic,
})

export const setSelectedProcedure = (procedure: string): DataAction<string> => ({
  type: BILLING_GUIDE_SET_SELECTED_PROCEDURE,
  data: procedure,
})

// Postcode Input Actions
export const setPostcodeInput = (value: string): DataAction<string> => ({
  type: BILLING_GUIDE_SET_POSTCODE_INPUT,
  data: value,
})

export const clearPostcodeSuggestions = (): BaseAction => ({
  type: BILLING_GUIDE_CLEAR_POSTCODE_SUGGESTIONS,
})
